<div class="form-group">
    <div class="d-flex align-items-center">
        <input id="typeahead-http" (keyup)="triggerSearch()" (keyup.enter)="addToTextFilters()" type="text"
            class="form-control col-lg-8 col-sm-9 col-10" [(ngModel)]="searchedWord"
            [placeholder]="'table.search_bar_placeholder' | translate" />
        <button type="button" class="btn btn-success icon-btn ml-2" [disabled]="!searchedWord"
            (click)="addToTextFilters()">
            <span class="title">{{'table.apply' | translate}}</span>
            <span class="material-icons">add</span>
        </button>
    </div>
</div>